<template>
  <div
    v-if="show"
    class="Nav"
    :class="{
      Nav_position: pageIndex == 1,
      fixedShow: shouNav,
      fixedFalse: !shouNav,
      headWhite: headWhite,
    }"
  >
    <div class="Nav_language">
      <Language :NavBar="NavBar" :pageIndex="pageIndex"></Language>
      <div class="hr_"></div>
      <User :NavBar="NavBar"></User>
    </div>
    <div class="Nav_conent">
      <Logo :NavBar="NavBar" :pageIndex="pageIndex"></Logo>
      <Menu class="Nav_box" :NavBar="NavBar"></Menu>
      <!-- <div class="Nav_box">
        <Menu :NavBar="NavBar"></Menu>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      NavBar: 1, //1为默认首页透明背景 白颜色字体 2为黑色字体
      pageIndex: 1, //判断是不是首页
      navOffsetTop: 0,
      lastOffsetTop: 0,
      shouNav: true,
      headWhite: false,
      activeIndex: 1,
      show: true
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.fiexdNav);
    this.getData();
  },
  destroyed() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.fiexdNav);
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to.path == "/sdgsindicators" ||
          to.path == "/login" ||
          to.path == "/register" ||
          to.path == "/forget"
        ) {
          this.show = false;
        } else {
          this.show = true;
        }
        if (
          to.path == "/" ||
          to.path == "/dataserver" ||
          to.path == "/dataSearch"
          // to.path == "/datahub" ||
          // to.path == "/sdgsindicators" ||
          // to.path == "/appMaket2"
        ) {
          this.pageIndex = 1;
          this.NavBar = 1; //判断是不是首页
          this.headWhite = false;
        } else {
          this.headWhite = true;
          this.pageIndex = 2;
          this.NavBar = 2;
        }
      },

      deep: true, // 深度监听
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },

  components: {
    Logo: () => import("../../PublicComponents/Nav/Logo/Logo.vue"),
    Language: () => import("../../PublicComponents/Nav/Language/Language.vue"),
    Menu: () => import("../../PublicComponents/Nav/Menu/Menu.vue"),
    User: () => import("../../PublicComponents/Nav/User/User.vue")
    // Nav: () => import("@/components/Test/Nav.vue"),
  },

  methods: {
    getData() {
      this.navOffsetTop = document.querySelector(".Nav").offsetTop;
    },
    fiexdNav() {
      // 2.获取当前页面的卷曲高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop > 80) {
        // 大于80px的时候 默认显示白色背景 及样式
        this.NavBar = 2;
        this.headWhite = true;
      } else {
        if (this.pageIndex == 2) {
          //小于80px 当等于第二个页面的时候 默认显示白色背景 及样式
          this.headWhite = true;
          this.NavBar = 2;
        } else {
          //小于80px 当等于第1个页面的时候 默认显示透明背景 及样式
          this.headWhite = false;
          this.NavBar = 1;
        }
      }
      const nav = document.querySelector(".Nav");
      if (scrollTop > this.lastOffsetTop && scrollTop > 220) {
        this.shouNav = false;
      } else {
        this.shouNav = true;
      }
      this.lastOffsetTop = scrollTop;
      // console.log(scrollTop, nav, this.navOffsetTop);
    },
    toMarket(val) {
      this.activeIndex = val;
      this.$router.push("/appMaket");
    },
    toNews(val) {
      this.activeIndex = val;
      this.$router.push("/news");
    },
    toDataHub(val) {
      this.activeIndex = val;
      this.$router.push("/datahub");
    },
    toIndex(val) {
      this.activeIndex = val;
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.activeNav {
  color: rgb(0, 174, 255) !important;
}
.Nav_position {
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.fixedShow {
  position: fixed;
  top: 0;
  transition: 0.3s;
}
.fixedFalse {
  position: fixed;
  top: -80px;
  transition: 0.3s;
}

.headWhite {
  background: #fff !important;
  box-shadow: 0px 1px 2px #d8d8d8;
}

.Nav {
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  z-index: 999;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0)
  );
  .Nav_language {
    width: 1200px;
    margin: 2px auto 0;
    text-align: right;
    display: flex;
    flex-direction: row;
    height: 24px;
    line-height: 24px;
    z-index: 99;
    justify-content: flex-end;
    .hr_ {
      height: 12px;
      margin-top: 8px;
      width: 1px;
      background: #ccc;
    }
  }
  .Nav_conent {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // align-items: center;
    width: 1200px;
    // width: 1280px;
    margin: 0 auto;

    .Nav_box {
      display: flex;
      flex-direction: row;
      margin-top: 8px;
      // line-height: 60px;
      justify-content: flex-end;
      // align-items: center;
      // height: 60px;
      width: 650px;

      ul {
        display: flex;
        flex-direction: row;
        margin-right: 100px;
        li {
          padding: 0 20px;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .NarBarUlColor1 li {
        color: #fff;
      }
      .NarBarUlColor2 li {
        color: #000;
      }
    }
  }
}
</style>